import * as React from 'react';
import { useNavigate } from '@reach/router';
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { HelpCircle } from "react-feather";

//components
import {
   Container,
   SectionForm,
   ButtonWrapper,
   MainHeading,
   Image,
   InfoText,
   InfoHeading,
   InfoHeadingCheck,
   Footer,
   ImgGlobalBlur
} from './StepOneStyle'
import { resolvedInvoice, resetLoadedData } from 'store/actions';
import { useInvoice } from "store/context";
import { nonCharacterSpecial } from 'helpers/validate'
import Background from 'assets/images/foto.jpg'
import Icon1 from 'assets/images/ICONOS_1.png'
import Icon2 from 'assets/images/ICONOS_02.png'
import Icon3 from 'assets/images/ICONOS_03.png'
import TicketImage from 'assets/images/ticket-me-facturo-1.jpg'
import TicketImage2 from 'assets/images/ticket-me-facturo-2.jpg'
import Input from 'components/Input/Input';
import Button from 'components/Button/Button'
import GlobalBlur from "components/GlobalBlur/index";
import { useForm } from 'hooks/useForm';
import { formatDate } from 'helpers/dateTools';

const version = process.env.REACT_APP_ENERSI_VERSION || "0.0.0"

function StepOne() {
   const navigate = useNavigate()
   const { state: { loadData }, dispatch } = useInvoice();
   const [show, setShow] = React.useState(false);
   const [showWebID, setShowWebID] = React.useState(false);
   const { inputValues, handleInputOnChange, runValidates, handleNewValues, fieldErrors } = useForm({
      date: formatDate(new Date()),
      rfc: '',
      webID: '',
      folio: ''},
      {
         date: { required: true },
         rfc: { required: true },
         webID: { required: true },
         folio: { required: true }
      }
   );
   const { date, rfc, webID, folio } = inputValues

   const handleDate = ({target}) => {
      handleNewValues({date: target.value})
   }

   const handleSubmit = async e => {
      e.preventDefault();
      if(runValidates()) return toast.error(' * Todos los campos son requeridos * ', { theme: 'colored' })
      await resolvedInvoice(dispatch, {rfc, webID, folio, date})
   }

   React.useEffect(() => {
      resetLoadedData(dispatch)
   }, [])
   React.useEffect(
      () => {
         if (loadData === 'resolved') {
            navigate('/facturar')
         }
         //eslint-disable-next-line react-hooks/exhaustive-deps
      }, [loadData]
   )

   return (
      <>
         <Image src={Background} alt='img' />
         <MainHeading>Factura Ticket</MainHeading>
         <Container >
            <SectionForm>
               <Input
                  requiredField={fieldErrors?.date || ''}
                  icon={Icon1}
                  type="date"
                  name='Fecha'
                  value={date}
                  onChange={(e) => handleDate(e)}
                  placeholder="Fecha"
                  inputProps={{ max: formatDate(new Date())}}
               />
               <Input
                  requiredField={fieldErrors?.rfc || ''}
                  icon={Icon1}
                  type="text"
                  name='rfc'
                  value={rfc}
                  onChange={handleInputOnChange}
                  placeholder="RFC"
               />
               <Input
                  requiredField={fieldErrors?.webID || ''}
                  span={<HelpCircle size={20} />}
                  icon={Icon2}
                  type="text"
                  name="webID"
                  value={webID}
                  onChange={handleInputOnChange}
                  placeholder="WEB ID"
                  onClickIcon={() => setShowWebID(true)}
               />
               <Input
                  requiredField={fieldErrors?.folio || ''}
                  span={<HelpCircle size={20} />}
                  icon={Icon3}
                  type="text"
                  name="folio"
                  value={folio}
                  onChange={handleInputOnChange}
                  placeholder="TICKET"
                  onClickIcon={() => setShow(true)}
               />

            </SectionForm>
            <ButtonWrapper>
               <Button handleClick={handleSubmit} disabled={loadData === 'pending' ? true: false }> {
                    loadData === "pending"
                     ? "Buscando..."
                     : "Buscar"
                    } </Button>    
            </ButtonWrapper>

            <InfoText>
               <InfoHeading>AVISO IMPORTANTE</InfoHeading>
               <strong>meFacturo.net</strong>, únicamente es proveedor de la plataforma de facturación.
               Si tuviera algún detalle con su ticket de facturación <br></br> le pedimos
               contactarse directamente con la Gasera a la que realizo su compra.
               <br></br><strong>Consideraciones:</strong> El ticket solo puede facturarse en este portal dentro del mismo mes del consumo.

               <InfoHeadingCheck>FAVOR DE VERIFICAR SUS DATOS ANTES DE GENERAR SU FACTURA</InfoHeadingCheck>
            </InfoText>
            <Footer>
               <p><strong>Todos los derechos reservados</strong></p>
               <p style={{ fontSize: '13px' }}>
                  Contactanos {" "}
                  <a style={{
                     textDecoration: 'revert',
                     color: 'white',
                  }}
                     href="mailto:facturacion@mefacturo.net?subject=Dudas con mi facturacion"
                  >
                     Aquí
                  </a>
               </p>
               <span>{version}</span>
            </Footer>
            <GlobalBlur isOpen={show} onClose={() => setShow(false)}>
               <ImgGlobalBlur
                  src={TicketImage}
                  alt="informacion del ticket"
               />
            </GlobalBlur>
            <GlobalBlur isOpen={showWebID} onClose={() => setShowWebID(false)}>
               <ImgGlobalBlur
                  src={TicketImage2}
                  alt="informacion del ticket"
               />
            </GlobalBlur>
         </Container>
         <ToastContainer autoClose={4000} />
      </>
   )
}

export default StepOne;